export default __webpack_public_path__ + "static/media/ratio-lock.66310bca.svg";